/* Valse premium Add to Cart sound
   - Plays only for real Add to Cart controls
   - Works on product pages, collection cards, and featured/home product cards
   - Does not play on Buy It Now / checkout / Shopify payment buttons
*/
(function(){
  var lastPlayedAt = 0;
  var audioContext = null;
  var soundVolume = 0.026; // soft luxury volume: audible but still premium and not annoying

  function getAudioContext(){
    var AudioCtx = window.AudioContext || window.webkitAudioContext;
    if(!AudioCtx) return null;
    if(!audioContext) audioContext = new AudioCtx();
    return audioContext;
  }

  function schedulePremiumTink(ctx){
    var nowMs = Date.now();
    if(nowMs - lastPlayedAt < 300) return;
    lastPlayedAt = nowMs;

    var t = ctx.currentTime + 0.006;

    var master = ctx.createGain();
    master.gain.setValueAtTime(0.0001, t);
    master.gain.exponentialRampToValueAtTime(soundVolume, t + 0.038);
    master.gain.exponentialRampToValueAtTime(0.0001, t + 0.52);
    master.connect(ctx.destination);

    // Soft luxury chime: rounded, low-volume, no harsh click.
    var bodyGain = ctx.createGain();
    bodyGain.gain.setValueAtTime(0.0001, t);
    bodyGain.gain.exponentialRampToValueAtTime(0.48, t + 0.032);
    bodyGain.gain.exponentialRampToValueAtTime(0.0001, t + 0.46);
    bodyGain.connect(master);

    var body = ctx.createOscillator();
    body.type = 'sine';
    body.frequency.setValueAtTime(783.99, t); // G5, softer premium start
    body.frequency.exponentialRampToValueAtTime(987.77, t + 0.14); // B5, gentle lift
    body.connect(bodyGain);
    body.start(t);
    body.stop(t + 0.42);

    var airGain = ctx.createGain();
    airGain.gain.setValueAtTime(0.0001, t + 0.05);
    airGain.gain.exponentialRampToValueAtTime(0.085, t + 0.09);
    airGain.gain.exponentialRampToValueAtTime(0.0001, t + 0.46);
    airGain.connect(master);

    var air = ctx.createOscillator();
    air.type = 'sine';
    air.frequency.setValueAtTime(1567.98, t + 0.06); // G6, very quiet shimmer
    air.frequency.exponentialRampToValueAtTime(1760, t + 0.18); // A6
    air.connect(airGain);
    air.start(t + 0.05);
    air.stop(t + 0.38);
  }

  function playAddToCartSound(){
    try{
      var ctx = getAudioContext();
      if(!ctx) return;

      if(ctx.state === 'suspended'){
        ctx.resume().then(function(){ schedulePremiumTink(ctx); }).catch(function(){});
      }else{
        schedulePremiumTink(ctx);
      }
    }catch(e){}
  }

  function isInsidePaymentOrCheckout(el){
    return !!(el && el.closest && el.closest('.shopify-payment-button, [data-shopify="payment-button"], .dynamic-checkout, [data-buy-now-card], .btn-buy-now, [name="checkout"]'));
  }

  function isAddToCartControl(el){
    if(!el || !el.closest) return false;
    if(isInsidePaymentOrCheckout(el)) return false;

    var control = el.closest([
      '.btn-add-to-cart',
      '.valse-product-form__add',
      'button[name="add"]',
      'input[name="add"]',
      '[data-add-to-cart]',
      '[data-action="add-to-cart"]',
      '[aria-label*="Add to cart" i]',
      '[aria-label*="Add to Cart" i]'
    ].join(','));

    if(!control) return false;
    if(control.disabled || control.getAttribute('aria-disabled') === 'true') return false;
    if(control.classList && (control.classList.contains('btn-sold-out') || control.classList.contains('sold-out'))) return false;
    return true;
  }

  function formIsAddToCart(form){
    if(!form || !form.matches) return false;
    if(isInsidePaymentOrCheckout(form)) return false;
    return form.matches('form[action*="/cart/add"], [data-product-card-form], .valse-product-form');
  }

  // pointerdown fires before other theme click handlers that may stop propagation.
  document.addEventListener('pointerdown', function(event){
    if(isAddToCartControl(event.target)) playAddToCartSound();
  }, true);

  // Keyboard/Enter support and fallback for browsers without Pointer Events.
  document.addEventListener('click', function(event){
    if(isAddToCartControl(event.target)) playAddToCartSound();
  }, true);

  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!formIsAddToCart(form)) return;
    var submitter = event.submitter || document.activeElement;
    if(!submitter || isAddToCartControl(submitter) || submitter.name === 'add') playAddToCartSound();
  }, true);

  window.valsePlayAddToCartTink = playAddToCartSound;
})();
